import { BaseWastesForm } from "./BaseWastesForm";
import { useContext } from "react";
import { OrderContext } from "../MainForms/OrderContext";

export function SaleWastesDetailsForm({ includeExtendedSaleWastesData }) {
  const { addressId, transactionType } = useContext(OrderContext) || {};

  return (
    <BaseWastesForm
      wasteFieldName="wastesDetails.saleWastes"
      addressId={addressId}
      isAddressIdRequired
      transactionType={transactionType}
      includeExtendedSaleWastesData={includeExtendedSaleWastesData}
    />
  );
}


export function TransportWastesDetailsForm({ fillWasteMass }) {
  return (<BaseWastesForm wasteFieldName="wastesDetails.transportWastes" fillWasteMass={fillWasteMass}/>);
}